import { Directive, ElementRef, EventEmitter, HostListener, Output, Renderer2 } from '@angular/core';
  
@Directive({ selector: '[longPress]' })
export class LongPressDirective{
    private touchTimeout: any;
    @Output() longpress = new EventEmitter();
    constructor(public el: ElementRef, public renderer: Renderer2) {}

    // @HostListener('mousedown') onmousedown():void {
    //     this.touchTimeout = setTimeout(() => {
    //         this.longpress.emit(true);
    //     }, 500);
    // }

    // @HostListener('mouseup') onmouseup():void {
    //     this.touchEnd();
    // }
    // @HostListener('mouseleave') onmouseleave():void {
    //     this.touchEnd();
    // }
    @HostListener('touchstart') touchstart():void {
        this.touchTimeout = setTimeout(() => {
            this.longpress.emit(true);
        }, 800);
    }
    
    @HostListener('touchend') touchend():void {
       this.touchEnd();
    }

    @HostListener('touchmove') touchmove():void {
        this.touchEnd();
     }

    private touchEnd():void {
        clearTimeout(this.touchTimeout);
    }
}
